import { Inject, inject, Injectable, InjectionToken, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { catchError, map, Observable, of } from 'rxjs';

import { AuthService } from '../../services/auth/auth.service';

export const AUTH_GUARD_CONFIG = new InjectionToken<AuthGuardConfig>('AUTH_GUARD_CONFIG');

export interface AuthGuardConfig {
    defaultPath: string;
}

@Injectable({
    providedIn: 'root'
})

//Guard for checking if browser / device has a jwt token
class AuthGuardClass {
    defaultPath: string;

    constructor(
        private authService: AuthService,
        private router: Router,
        @Optional() @Inject(AUTH_GUARD_CONFIG) config?: AuthGuardConfig
    ) {
        this.defaultPath = config?.defaultPath || '/login';
    }

    //Check if a token exists
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        // console.log('auth guard called');

        const url: string = state.url;

        return (
            this.authService.tokenExists()?.pipe(
                map(res => {
                    if (res) return true;

                    this.authService.setRedirectRouterUrl(url);
                    this.router.navigate([this.defaultPath]);

                    return false;
                }),
                catchError(() => {
                    this.router.navigate([this.defaultPath]);
                    return of(false);
                })
            ) || false
        );
    }
}

export const AuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    return inject(AuthGuardClass).canActivate(next, state);
};
